import { sponsorAxiosInstance } from "./base-service";
import { PassApproval } from "../models/IPassApprovals";
import { AxiosResponse } from "axios";
import { PassApprovalDetail } from "models/IPassApprovalDetail";

export const GetPassApprovals = (): Promise<AxiosResponse<PassApproval[]>> => {
  return sponsorAxiosInstance.get<PassApproval[]>(
    `v1/Approval/Approver/CurrentUser`
  );
};

export const ApprovalDetails = (
  approvalId: number
): Promise<AxiosResponse<PassApprovalDetail>> => {
  return sponsorAxiosInstance.get<PassApprovalDetail>(
    `/v1/Approval/${approvalId}/Info`
  );
};

export const ApproveOrDeclinePass = async (
  approvalId: number,
  isApprove: boolean
): Promise<AxiosResponse> => {
  return sponsorAxiosInstance.put<void>(
    `/v1/Approval/${approvalId}/${isApprove ? "Approve" : "Deny"}`
  );
};
